import EcoSpace from 'eco-design/base/eco-space';
import EcoVideo from 'eco-design/base/eco-video';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import AnimatedSection from '../AnimatedSection';
import CommonTitle from '../CommonTitle';
import getLocal from '@/app/utils/i18n';

interface PriorityOutputs2Props {
    load?: boolean;
    pageType: 'max' | 'ultra';
}

const PriorityOutputs2: React.FC<PriorityOutputs2Props> = ({ load = false, pageType = 'max' }) => {
    const { t } = useLang('PriorityOutputs2');

    const { locale } = getLocal();

    const videoMap = {
        max: {
            us: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1758178058932/PC-%E8%87%AA%E5%8A%A8-2%E5%BA%A6%E7%94%B5-us.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1758871839632-zxh9k3-compressed-%E8%A7%86%E9%A2%912.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1758178081075/M-%E8%87%AA%E5%8A%A8-2%E5%BA%A6%E7%94%B5-us.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1758871855902-ictkhl-compressed-%E8%83%8C%E6%99%AF%E5%92%8C%E6%89%8B%E6%9C%BA%E7%95%8C%E9%9D%A2%E4%B8%80%E4%BD%93%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2.jpg',
            },
            ca: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1758178058932/PC-%E8%87%AA%E5%8A%A8-2%E5%BA%A6%E7%94%B5-us.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1758871839632-zxh9k3-compressed-%E8%A7%86%E9%A2%912.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1758178081075/M-%E8%87%AA%E5%8A%A8-2%E5%BA%A6%E7%94%B5-us.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1758871855902-ictkhl-compressed-%E8%83%8C%E6%99%AF%E5%92%8C%E6%89%8B%E6%9C%BA%E7%95%8C%E9%9D%A2%E4%B8%80%E4%BD%93%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2.jpg',
            },
            eu: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761641781474/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E8%87%AA%E5%8A%A8_PC_EN_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761126098352-tuqjp8-compressed-%E8%A7%86%E9%A2%91-EN.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761641781294/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E8%87%AA%E5%8A%A8_M_EN_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761119560596-hdu3ga-compressed-%E4%B8%80%E4%BD%93-EN.jpg',
            },
            uk: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1765768536782/PC.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761126098352-tuqjp8-compressed-%E8%A7%86%E9%A2%91-EN.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1765768401157/M.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761119560596-hdu3ga-compressed-%E4%B8%80%E4%BD%93-EN.jpg',
            },
            de: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761641883541/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E8%87%AA%E5%8A%A8_PC_DE_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761126080885-6vfxc9-compressed-%E8%A7%86%E9%A2%91-DE.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761641883446/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E8%87%AA%E5%8A%A8_M_DE_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761119543640-ib99o9-compressed-%E4%B8%80%E4%BD%93-DE.jpg',
            },
            fr: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761641912943/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E8%87%AA%E5%8A%A8_PC_FR_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761126141090-j1e3xt-compressed-%E8%A7%86%E9%A2%91-FR.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761641912697/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E8%87%AA%E5%8A%A8_M_FR_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761119606346-cjrsoe-compressed-%E4%B8%80%E4%BD%93-FR.jpg',
            },
            es: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761641937372/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E8%87%AA%E5%8A%A8_PC_ES_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761126126646-vobsz0-compressed-%E8%A7%86%E9%A2%91-ES.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761641937227/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E8%87%AA%E5%8A%A8_M_ES_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761119591485-nl6r2o-compressed-%E4%B8%80%E4%BD%93-ES.jpg',
            },
            it: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761641967226/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E8%87%AA%E5%8A%A8_PC_IT_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761126110899-2q9vjs-compressed-%E8%A7%86%E9%A2%91-IT.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761641967087/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E8%87%AA%E5%8A%A8_M_IT_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761119575972-rogeyb-compressed-%E4%B8%80%E4%BD%93-IT.jpg',
            },
        },
        ultra: {
            us: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1758178105544/PC-%E8%87%AA%E5%8A%A8-3%E5%BA%A6%E7%94%B5-us.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1758871801552-6el3p3-compressed-%E9%9D%99%E6%80%81%E5%9B%BE-%E8%8B%B1%E8%AF%AD%202.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1758178114250/M-%E8%87%AA%E5%8A%A8-3%E5%BA%A6%E7%94%B5-us.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1758871820881-ab7n34-compressed-%E8%83%8C%E6%99%AF%E5%92%8C%E6%89%8B%E6%9C%BA%E7%95%8C%E9%9D%A2%E4%B8%80%E4%BD%93%E8%A7%86%E9%A2%91.jpg',
            },
        },
    };

    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    // @ts-ignore
    const videoResMap = videoMap[pageType as keyof typeof videoMap][isEU ? locale : 'us'];

    return (
        <div className={styles.PriorityOutputs2} data-section-id="d3m-priority-outputs2">
            {load && (
                <>
                    <EcoVideo className="bg video-pc" key={1} pc={videoResMap.pc} poster={videoResMap.pcPoster} autoPlay={true} loop={true} />
                    <EcoVideo className="bg video-h5" key={2} pc={videoResMap.h5} poster={videoResMap.h5Poster} autoPlay={true} loop={true} />
                </>
            )}
            {/* <EcoImg className="bg" pc="https://websiteoss.ecoflow.com/figma-uploads/1757488979318-xrfwk1-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97.jpg" /> */}
            {/* <EcoImg
                className="phone"
                pc="https://websiteoss.ecoflow.com/figma-uploads/1757669087982-hla8dn-compressed-%E5%8F%8C%E8%B7%AF%E7%95%8C%E9%9D%A2.png"
            /> */}
            <div className="content">
                {/* <EcoSpace hPc="100px" hPad="50px" hH5="60px" /> */}
                <CommonTitle title={t('title')} desc={t('desc')} sub_title={t('sub_title')} />
            </div>
        </div>
    );
};

export default PriorityOutputs2;
